import React from "react";
import Link from "next/link";
import Image from "next/image";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import { title } from "process";
import "./styles/_product-overview-section.module.scss";

const ProductOverviewSection = ({ productOverviewData }) => {
    return (
        <div className="product-overview-sections">
            <div className="container">
                <div className="d-flex">
                    <div className="left-block">
                        <h2>{productOverviewData.title}</h2>
                        <div className="btn-flex">
                            <Link href={productOverviewData.buttons[0].link} className={"ahref-btn primary arrow-white"} target="_blank">
                                {productOverviewData.buttons[0].label}
                            </Link>
                            <Link href={productOverviewData.buttons[1].link} className={"ahref-btn secondary arrow-blue"}>
                                {productOverviewData.buttons[1].label}
                            </Link>
                        </div>
                    </div>
                    <div className="right-block">
                        <p>{productOverviewData.description}</p>
                        <div className="works-well-with">
                            <div className="section-tag">Works Well With</div>

                            <div className="works-flex-card">
                                {(productOverviewData.worksWellWith || [])
                                    .filter((item) => item?.link)
                                    .map((item, index) => (
                                        <div className="work-card" key={item.link ?? index}>
                                            <Link href={item.link} className="works-card">
                                                {item.icon}
                                                <p>{item.title}</p>
                                            </Link>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

ProductOverviewSection.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    buttons: PropTypes.array,
    products: PropTypes.array,
}
export default ProductOverviewSection